
// SVG Icon: upload-thin
export default { id: "terriajs-upload-thin" };
export const id = "terriajs-upload-thin";
export const name = "upload-thin";
